import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/ProjectsAndVessels/Ship/add'
import constant from '../../../constant'
import { toast } from 'react-toastify'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { v3_create_ship_crew_account, v3_edit_ship, v3_reset_ship_crew_account_password } from '../../../actions/v3/projectAndVessel'
const Add = (props) => {

    const location = useLocation();
    const { data, page } = location.state || {};
    const onSubmit = async (model) => {
        model.previousName = JSON.parse(atob(data))['NAME']
        model.shipId = JSON.parse(atob(data))['ID']

        const res = await v3_edit_ship(model);
        if (res.status) {
            toast.success(res.result.message)
            if (!res.result.temporaryCredentials?.length) {
                props.history.push(constant.Authedcomponent.listShipMasterData.url, {
                    page: page // Replace 'yourData' with the data you want to pass
                });
            }
        }
        else {
            toast.error(res.error)
        }
        return res;
    }
    return (
        <React.Fragment>
            <Layout
                title={'Vessels'}>
                <Form
                    title={'Edit Vessel'}
                    onSubmit={onSubmit}
                    onCreateCrewAccount={(post) => v3_create_ship_crew_account(JSON.parse(atob(data)).ID, post)}
                    onResetCrewPassword={(post) => v3_reset_ship_crew_account_password(JSON.parse(atob(data)).ID, post)}
                    data={JSON.parse(atob(data))}
                    buttonName={'Save Vessel'}
                    onCredentialsAcknowledged={() => props.history.push(constant.Authedcomponent.listShipMasterData.url, { page })}

                />
            </Layout>

        </React.Fragment>
    )
}

export default Add
